/**   
 * api接口统一管理
 */
import { get, post } from './setting'

const user_api = {
    userinfo : '/api/user/getUserInfo',
    queryplayer : '/api/user/getNickName',
    bind : '/api/user/bind',
    my_task : '/api/userTask/getTaskList',
    share : '/api/share/getCode',
    share_apply : '/api/share/bindCode',
    invite_info : '/api/share/getNickName',
    invite_list : '/api/share/GetListByMode?mode=0',
}

export const apiUserinfo = p => get(user_api.userinfo, p);
export const apiUserQuery = p => get(user_api.queryplayer, p);
export const apiUserBind = p => post(user_api.bind, p);
export const apiShare = p => get(user_api.share, p);
export const apiShareApply = p => post(user_api.share_apply, p);
export const apiInviteList = p => get(user_api.invite_list, p);
export const apiInviteInfo = p => get(user_api.invite_info, p);